import {  useState, useEffect, useContext } from "react";
import { useSearchParams } from 'react-router-dom';

import 'src/css/Nav.scss';

const tax = [
    {
        key: 'metadata.dc_subject_system',
        name: 'Sistema',
        value: 'sistema',
        items: [
            {
                value: 'nervioso',
                name: 'Nervioso',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'cerebro',
                        name: 'Cerebro',
                        sistema: 'nervioso'
                    },
                    {
                        value: 'cerebelo',
                        name: 'Cerebelo',
                        sistema: 'nervioso'
                    },
                    {
                        value: 'tallo cerebral',
                        name: 'Tallo cerebral',
                        sistema: 'nervioso'
                    },
                    {
                        value: 'medula espinal',
                        name: 'Médula espinal',
                        sistema: 'nervioso'
                    },
                    {
                        value: 'meninges',
                        name: 'Meninges',
                        sistema: 'nervioso'
                    },
                ],

            },
            {
                value: 'musculo esqueletico',
                name: 'Músculo esquelético',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'hueso',
                        name: 'Huesos',
                        key: 'metadata.dc_subject_tissue',
                        sistema: 'musculo esqueletico'
                    },
                    {
                        value: 'articulaciones',
                        name: 'Articulaciones',
                        sistema: 'musculo esqueletico'
                    },
                    {
                        value: 'musculo',
                        name: 'Músculos',
                        key: 'metadata.dc_subject_tissue',
                        sistema: 'musculo esqueletico'
                    },
                ],

            },
            {
                value: 'linfoide',
                name: 'Hemolinfático',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'bazo',
                        name: 'Bazo',
                        sistema: 'hemolinfatico'
                    },
                    {
                        value: 'timo',
                        name: 'Timo',
                        sistema: 'hemolinfatico'
                    },
                    {
                        value: 'linfonodos',
                        name: 'Linfonodos',
                        sistema: 'hemolinfatico'
                    },
                ],

            },
            {
                value: 'endocrino',
                name: 'Endócrino',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'hipofisis',
                        name: 'Hipófisis',
                        sistema: 'endocrino'
                    },
                    {
                        value: 'tiroides',
                        name: 'Tiroides',
                        sistema: 'endocrino'
                    },
                    {
                        value: 'paratiroides',
                        name: 'Paratiroides',
                        sistema: 'endocrino'
                    },
                    {
                        value: 'adrenal',
                        name: 'Adrenal',
                        sistema: 'endocrino'
                    },
                    {
                        value: 'pancreas endocrino',
                        name: 'Páncreas endócrino',
                        sistema: 'endocrino'
                    },
                ],

            },
        ]
    },
    {
        key: 'metadata.dc_subject_system',
        name: 'Aparato',
        value: 'aparato',
        items: [
            {
                value: 'cardiovascular',
                name: 'Cardiovascular',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'corazon',
                        name: 'Corazón',
                        aparato: 'cardiovascular'
                    },
                    {
                        value: 'arteria',
                        name: 'Arteria',
                        aparato: 'cardiovascular'
                    },
                    {
                        value: 'vena',
                        name: 'Vena',
                        aparato: 'cardiovascular'
                    },
                    {
                        value: 'vaso linfatico',
                        name: 'Vaso linfático',
                        aparato: 'cardiovascular'
                    },
                ],
            },
            {
                value: 'respiratorio',
                name: 'Respiratorio',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'cavidad nasal',
                        name: 'Cavidad nasal',
                        aparato: 'respiratorio'
                    },
                    {
                        value: 'faringe',
                        name: 'Faringe',
                        aparato: 'respiratorio'
                    },
                    {
                        value: 'bolsas guturales',
                        name: 'Bolsas guturales',
                        aparato: 'respiratorio'
                    },
                    {
                        value: 'laringe',
                        name: 'Laringe',
                        aparato: 'respiratorio'
                    },
                    {
                        value: 'traquea',
                        name: 'Tráquea',
                        aparato: 'respiratorio'
                    },
                    {
                        value: 'pulmon',
                        name: 'Pulmón',
                        aparato: 'respiratorio'
                    },
                ],

            },
            {
                value: 'digestivo',
                name: 'Digestivo',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'cavidad bucal',
                        name: 'Cavidad bucal',
                        aparato: 'digestivo'
                    },
                    {
                        value: 'glandulas salivales',
                        name: 'Glándulas salivales',
                        aparato: 'digestivo'
                    },
                    {
                        value: 'esofago',
                        name: 'Esófago',
                        aparato: 'digestivo'
                    },
                    {
                        value: 'estomago',
                        name: 'Estómago',
                        aparato: 'digestivo'
                    },
                    {
                        value: 'compartimientos gastricos',
                        name: 'Compartimientos gástricos',
                        aparato: 'digestivo'
                    },
                    {
                        value: 'intestino',
                        name: 'Intestino',
                        aparato: 'digestivo'
                    },
                    {
                        value: 'higado',
                        name: 'Hígado',
                        aparato: 'digestivo'
                    },
                    {
                        value: 'pancreas',
                        name: 'Páncreas',
                        aparato: 'digestivo'
                    },
                    {
                        value: 'peritoneo',
                        name: 'Peritoneo',
                        aparato: 'digestivo'
                    },
                ],

            },
            {
                value: 'urinario',
                name: 'Urinario',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'rinon',
                        name: 'Riñon',
                        aparato: 'urinario'
                    },
                    {
                        value: 'ureteres',
                        name: 'Uréteres',
                        aparato: 'urinario'
                    },
                    {
                        value: 'vejiga urinaria',
                        name: 'Vejiga urinaria',
                        aparato: 'urinario'
                    },
                    {
                        value: 'uretra',
                        name: 'Uretra',
                        aparato: 'urinario'
                    },
                ],

            },
            {
                value: 'reproductor',
                name: 'Reproductor',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'ovario',
                        name: 'Ovario',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'utero',
                        name: 'Útero',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'placenta',
                        name: 'Placenta',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'vagina',
                        name: 'Vagina',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'vulva',
                        name: 'Vulva',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'glandula mamaria',
                        name: 'Glándula mamaria',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'testiculo',
                        name: 'Testículo',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'epididimo',
                        name: 'Epididimo',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'pene',
                        name: 'Pene',
                        aparato: 'reproductor'
                    },
                    {
                        value: 'glandulas anexas',
                        name: 'Glándulas anexas',
                        aparato: 'reproductor'
                    },
                ],

            },
            {
                value: 'tegumentario',
                name: 'Tegumentario',
                key: 'metadata.dc_subject_organ',
                organos: [
                    {
                        value: 'piel',
                        name: 'Piel',
                        aparato: 'tegumentario'
                    },
                    {
                        value: 'glandulas anexas',
                        name: 'Glándulas anexas',
                        aparato: 'tegumentario'
                    },
                ],

            },
        ]
    },
    {
        key: 'caso.especie',
        name: 'Especies',
        value: 'especies',
        items: [
            {
                value: 'ave',
                name: 'Ave'
            },
            {
                value: 'cerdo',
                name: 'Cerdo'
            },
            {
                value: 'bovino',
                name: 'Bovino'
            },
            {
                value: 'ovino',
                name: 'Ovino'
            },
            {
                value: 'caprino',
                name: 'Caprino'
            },
            {
                value: 'perro',
                name: 'Perro'
            },
            {
                value: 'gato',
                name: 'Gato'
            },
            {
                value: 'silvestres',
                name: 'Silvestres'
            },
            {
                value: 'varios',
                name: 'Varios'
            },
        ]
    }
];

export default function Nav() {
    const [searchParams, setSearchParams] = useSearchParams();

    const [top, setTop] = useState(null);
    const [mid, setMid] = useState(null);
    const [bot, setBot] = useState(null);

    const updateSP = () => {
        let sp = {};
        if (top && mid) {
            sp[top.key] = mid.value
            sp.path = top.value + '.' + mid.value;
        };
        if (mid && bot) {
            sp[bot.key || mid.key] = bot.value
            sp.path += '.' + bot.value
        };

        let query = searchParams.get('query');
        if (query) sp.query = query;
        for (const [key, val] of Object.entries(sp)) {
            if (val != searchParams.get(key)) {
                setSearchParams(sp)
            }
        }
        if (!top) setSearchParams(sp);
    }

    useEffect(() => {
        updateSP();
    }, [top, mid, bot]);

    useEffect(() => {
        let path = searchParams.get('path');
        if (path) {
            let [tp, mp, bp] = path.split('.');
            if (tp) {
                let t = tax.find(t => t.value === tp);
                setTop(t)
                if (t && mp) {
                    let m = t.items.find(m => m.value === mp)
                    setMid(m)
                    if (m && bp) {
                        let b = m.organos.find(b => b.value === bp)
                        setBot(b)
                    }
                }
            }
        }
    }, []);

    const updatePath = (l, nv) => {
        switch (l) {
            case 'top':
                setTop(v => v && v.value === nv.value ? null : nv)
                setMid(null)
                setBot(null)
                break;
            case 'mid':
                setMid(v => v && v.value === nv.value ? null : nv)
                setBot(null)
                break;
            case 'bot':
                setBot(v => v && v.value === nv.value ? null : nv)
                break;
        }
    }

    return (
        <>
            {/* <div>{`${top?.value}  ${mid?.value}   ${bot?.value}`}</div> */}
            <div className="nav top">
                {tax.map(t =>
                <span className={`lnk ${t.value === top?.value && 'selected'} ${t.value}`}
                    key={t.value}
                    onClick={() => updatePath('top', t)}>{t.name}</span>
                )}
                {/* <span className="lnk ayuda">Ayuda</span> */}
            </div>
            {top &&
            <div className="nav mid">
                { top?.items?.map(m =>
                <span className={`lnk ${m.value === mid?.value && 'selected'}`}
                    key={m.value}
                    onClick={() => updatePath('mid', m)}>{m.name}</span>
                )}
            </div>
            }
            {mid && mid.organos &&
            <div className="nav bot">
                { mid?.organos?.map(b =>
                <span className={`lnk ${b.value === bot?.value && 'selected'}`}
                    key={b.value}
                    onClick={() => updatePath('bot', b)}>{b.name}</span>
                )}
            </div>
            }
        </>
    );
};
